import roller_shutter_settings_gen_3 from '@devices/settings/common_settings/roller_shutter_settings_gen_3';
import { addon_plus_devices_g3 } from '@devices/settings/device_settings/addon_sensors';

export default {
	// This is a 2PM G4, but only with a roller mode
	name: 'ShellyShutter',
	friendly_name: 'Shutter',
	family: 'relay',
	isPM: true,
	addons: addon_plus_devices_g3,
	reset_from_input: true,
	modes: {
		roller: {
			channels: 1,
			notifications: ['offline', 'device_problem'],
			slider: true,
			settings: roller_shutter_settings_gen_3,
		},
	},
};
